<template>
    <!-- Navigation -->
    <nav id="Header" class="navbar navbar-icon-top navbar-expand-sm navbar-light bg-light fixed-top">
        <router-link class="navbar-brand" to="/" style="color: #4590f3;">
            <img :src="require('@/assets/img/bg/logo_kara.png')" class="img-logo" width="45%"/></router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse col" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <!--<li class="nav-item active">
                  <router-link data-toggle="collapse" data-target="#navbarSupportedContent" class="nav-link" to="/">
                    <i class="fa fa-home"></i>
                    Home
                  </router-link>
                </li>-->
                <div class="search-bg">
                    <li class="input-group" style="margin-top:15px;">
                        <input class="form-control" type="text" maxlength="17" v-model="searchText" placeholder="활동 검색"
                               aria-label="Search" style="border-radius: 20px; z-index: 1;" @keyup.enter="eventEnter()">
                        <div class="input-group-append icon">
                            <router-link data-toggle="collapse" data-target="#navbarSupportedContent"
                                         style="color:#7c7c7d;"
                                         :to="{name : 'activitySearch', params : { size:'10', page:'0', target:'title', value:searchText, query:`title:${searchText}` }}"
                                         id="button-addon">
                                <i class="fa fa-search"></i>
                            </router-link>
                        </div>
                    </li>
                    <span class="glyphicon glyphicon-search"></span>
                </div>
                <!--<div class="form-inline my-2 my-lg-0 bg-dark">
                  <div class="input-group" >
                    <input class="form-control"  type="text" maxlength="17" v-model="searchText" placeholder="Search" aria-label="Search" style="border-radius: 20px; z-index: 1;" @keyup.enter="eventEnter()"> &nbsp;
                    <div class="input-group-append icon">
                      <router-link  data-toggle="collapse" data-target="#navbarSupportedContent" style="color:#7c7c7d;"
                                    :to="{name : 'activitySearch', params : { size:'10', page:'0', target:'title', value:searchText, query:`title:${searchText}` }}" id="button-addon">
                        <i class="fa fa-search"></i>
                      </router-link>
                    </div>
                  </div>
                  <span class="glyphicon glyphicon-search"></span>
                </div>-->

                <li class="nav-item dropdown" v-if="$auth.check()">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownNoti" role="button"
                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-on:click="updateAlarmReadAll()">
                        <i class="fa fa-bell-o">
                            <span class="badge badge-danger" v-if="getUnreadCount() > 0">{{getUnreadCount()}}</span>
                        </i>
                        알림
                    </a>
                    <div class="dropdown-menu dropdown-menu-right alarmList" aria-labelledby="navbarDropdownNoti">
                        <AlarmUnreadList v-if="$auth.check()" ></AlarmUnreadList>
                    </div>
                </li>
                
                <!-- 게시판 드롭다운 메뉴 -->
                <li class="nav-item dropdown  dropdown-menu-right">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownBoard" role="button"
                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-list-alt"></i>
                        게시판
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownBoard">
                        <router-link class="dropdown-item" to="/notice">
                            <i class="fa fa-bullhorn"></i> 공지사항
                        </router-link>
                        <router-link class="dropdown-item" to="/qna">
                            <i class="fa fa-question-circle"></i> Q&A
                        </router-link>
                        <router-link class="dropdown-item" to="/archive">
                            <i class="fa fa-archive"></i> 자료집
                        </router-link>
                        <div class="dropdown-divider"></div>
                        <router-link class="dropdown-item" to="/schedule">
                            <i class="fa fa-calendar"></i> 스케줄
                        </router-link>
                    </div>
                </li>
                
                <li  v-if="$auth.check()" class="nav-item dropdown  dropdown-menu-right">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownProfile"
                       role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-user-o">
                            <!--<span class="badge badge-primary">0</span>-->
                        </i>
                        회원 메뉴
                    </a>
                    <div class="dropdown-menu  dropdown-menu-right" aria-labelledby="navbarDropdownProfile"
                         v-if="$auth.check()">
                            <router-link
                                         class="dropdown-item" :to="{name:'mypage'}"><i class="fa fa-user-o"></i> 내 정보
                            </router-link>
                        <div class="dropdown-divider"></div>
                        <a href="#none;"
                           class="dropdown-item" @click="$auth.logout()"><i class="fa fa-sign-out"></i> 로그아웃 </a>
                    </div>
                </li>
                <li class="nav-item dropdown  dropdown-menu-right"
                    v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownAdmin" role="button"
                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-wrench"></i>
                        관리자
                    </a>
                    <div class="dropdown-menu  dropdown-menu-right" aria-labelledby="navbarDropdownAdmin">
                        <router-link  class="dropdown-item"
                                     to="/activity/regist">
                            <i class="fa fa-plus-circle"></i> 활동을 등록하세요
                        </router-link>
                        <div class="dropdown-divider"></div>
                        <adminMenu></adminMenu>
                    </div>
                </li>
            </ul>
            <div class="pc-only">
                <router-link v-show="!$auth.check()" to="/login" class="col" style="width: 100%;color:#7fb7e8;">
                    <i class="fa fa-sign-in"></i> 로그인
                </router-link>
            </div>

            <div class="row mobile-only" style="background-color: #ECECED;padding:5px;">
                <a  v-show="$auth.check()" @click="logout"
                   class="col" style="width: 100%; color:#7fb7e8 ">
                    <i class="fa fa-sign-out"></i> 로그아웃
                </a>
                <router-link  v-show="!$auth.check()"
                             to="/login" class="col" style="width: 100%;color:#7fb7e8;">
                    <i class="fa fa-sign-in"></i> 로그인
                </router-link>

                <button type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"  id="navCloseButton"
                        style="border:none;outline:none; background-color:#ECECED " aria-expanded="false">
                    <img :src="require('@/assets/icon/btn_clo.png')" style="width: 70%; height: 70%">
                </button>
            </div>
        </div>

    </nav>

</template>

<script>
    //import MyLevel from '@/components/MyLevel.vue'
    import AlarmUnreadList from '@/components/member/AlarmUnreadList.vue'
    import adminMenu from '@/components/admin/AdminMenu.vue'

    export default {
        name: 'Header',
        props: {
            msg: String
        },
        data() {
            return {
                unreadCount: 0,
                searchText: ''
            }
        },
        components: {
            //MyLevel,
            AlarmUnreadList, adminMenu
        },
        methods: {
            logout() {
                this.$auth.logout();
            },
            getUnreadCount() {
                if (!this.$auth.check()) return;
                let me = this;
                let url = process.env.VUE_APP_MEMBER_API_URL + `/alarm/unreadCount/${this.$auth.user().id}`;
                this.axios.get(url)
                    .then(function (res) {
                        me.unreadCount = res.data;
                    }).catch(function (error) {
                    console.log(error);
                });
                return this.unreadCount;
            },
            eventEnter() {
                this.$router.push({
                    name: 'activitySearch',
                    params: {
                        size: '10',
                        page: '0',
                        target: 'title',
                        value: this.searchText,
                        query: `title:${this.searchText}`
                    }
                })
            },
            updateAlarmReadAll() {
                let me = this;

                this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/alarm/readall/${this.$auth.user().id}`)
                    .then(function () {

                        me.getUnreadCount()
                    }).catch(function (error) {
                    console.log(error);


                });

            }
        },
        created() {
        },
    }
</script>
<style scoped>
    @import url("//maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

    .navbar-icon-top .navbar-nav .nav-link > .fa {
        position: relative;
        width: 36px;
        font-size: 24px;
    }

    .navbar-icon-top .navbar-nav .nav-link > .fa > .badge {
        font-size: 0.75rem;
        position: absolute;
        right: 0;
        font-family: sans-serif;
    }

    .navbar-icon-top .navbar-nav .nav-link > .fa {
        top: 3px;
        line-height: 12px;
    }

    .navbar-icon-top .navbar-nav .nav-link > .fa > .badge {
        top: -10px;
    }

    @media (min-width: 576px) {
        .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link {
            text-align: center;
            display: table-cell;
            height: 70px;
            vertical-align: middle;
            padding-top: 0;
            padding-bottom: 0;
        }

        .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link > .fa {
            display: block;
            width: 48px;
            margin: 2px auto 4px auto;
            top: 0;
            line-height: 24px;
        }

        .navbar-icon-top.navbar-expand-sm .navbar-nav .nav-link > .fa > .badge {
            top: -7px;
        }


    }

    @media (min-width: 768px) {
        .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link {
            text-align: center;
            display: table-cell;
            height: 70px;
            vertical-align: middle;
            padding-top: 0;
            padding-bottom: 0;
        }

        .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link > .fa {
            display: block;
            width: 48px;
            margin: 2px auto 4px auto;
            top: 0;
            line-height: 24px;
        }

        .navbar-icon-top.navbar-expand-md .navbar-nav .nav-link > .fa > .badge {
            top: -7px;
        }

    }

    @media (min-width: 992px) {
        .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link {
            text-align: center;
            display: table-cell;
            height: 70px;
            vertical-align: middle;
            padding-top: 0;
            padding-bottom: 0;
        }

        .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link > .fa {
            display: block;
            width: 48px;
            margin: 2px auto 4px auto;
            top: 0;
            line-height: 24px;
        }

        .navbar-icon-top.navbar-expand-lg .navbar-nav .nav-link > .fa > .badge {
            top: -7px;
        }

    }

    @media (min-width: 1200px) {
        .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link {
            text-align: center;
            display: table-cell;
            height: 70px;
            vertical-align: middle;
            padding-top: 0;
            padding-bottom: 0;
        }

        .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link > .fa {
            display: block;
            width: 48px;
            margin: 2px auto 4px auto;
            top: 0;
            line-height: 24px;
        }

        .navbar-icon-top.navbar-expand-xl .navbar-nav .nav-link > .fa > .badge {
            top: -7px;
        }

    }

    .icon {
        position: absolute;
        right: 0px;
        margin-top: 6px;
        margin-right: 15px;
        z-index: 2;
    }

    .fixed-top {
        z-index: 930;
    }

    @media (max-width: 575.98px) {
        .search-bg {
            background-color: #7fb7e8;
            padding: 0 10px 10px 10px;
            margin-right: -15px;
            margin-left: -15px;
        }
    }

    .fa {
        position: relative;
    }

    .navbar-nav .dropdown-menu {
        border: 1px solid gray;
        padding-left: 10px;
    }

    .alarmList {
        overflow-y: scroll;
        max-height: 400px;
    }
</style>
